/**
 * Loads the saved Gradient and FastNoiseLite files a procedural texture names
 * (`textures/textureSourceFiles.ts`). A file that fails to load shows as a **Missing resource**, and
 * the texture draws nothing. While one loads, the texture is on its way, not missing, and `ref`
 * resolves to nothing: a build started without a source would be thrown away.
 */
import { useCallback, useMemo } from 'react';
import { textureSourceFiles } from './textures/textureSourceFiles.js';
import { PARSED_RESOURCES, useCachedFiles } from './useLoadedFiles.js';
export function useTextureSources(ref, externalResources, internalResources) {
    const pools = useMemo(() => ({ externalResources, internalResources }), [externalResources, internalResources]);
    const files = useMemo(() => textureSourceFiles(ref, pools), [ref, pools]);
    const plan = useCallback(() => files, [files]);
    // A texture that names no file listens to no bus: most Texture2D slots are images.
    const { loadedFile, isLoading } = useCachedFiles(files.length > 0 ? PARSED_RESOURCES : null, plan);
    return { pools, loadedFile, isLoading, readyRef: isLoading ? undefined : ref };
}
//# sourceMappingURL=useTextureSources.js.map